import useSWR from 'swr'
import { api } from '@/lib/api'
import { PrefectureDashboardResponse } from '@/types'
import useFilterStore from '@/store/useFilterStore'

export const usePrefectureDashboardData = () => {
  const { selectedGeneration, startYear, endYear, selectedPrefectures } = useFilterStore()

  const params = {
    ...(startYear && { startYear }),
    ...(endYear && { endYear }),
    ...(selectedPrefectures.length > 0 && { prefectureIds: selectedPrefectures }),
    ...(selectedGeneration && { generation: selectedGeneration }),
  }

  // デバッグ用ログ
  console.log('Prefecture Dashboard params:', params)

  // パラメータが変更されたときに強制的に再取得
  const cacheKey = JSON.stringify(params)

  const { data, error, isLoading, mutate } = useSWR<PrefectureDashboardResponse>(
    ['prefecture-dashboard', cacheKey],
    () => api.getPrefectureDashboardData(params),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
      dedupingInterval: 1000,
      refreshInterval: 0,
      keepPreviousData: true,
      revalidateOnMount: true,
    }
  )

  // デバッグ用ログ
  console.log('Prefecture Dashboard data result:', { data, error, isLoading })

  return {
    data,
    error,
    isLoading,
    mutate,
  }
}
